export enum ContactType {
  EMAIL = 'Email',
  PHONE = 'Phone',
}
